import { useState, useCallback } from 'react';

export const useFlashMessages = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const clearMessages = useCallback(() => {
    setError('');
    setSuccess('');
  }, []);

  const clearError = useCallback(() => {
    setError('');
  }, []);

  const clearSuccess = useCallback(() => {
    setSuccess('');
  }, []);

  return {
    error,
    success,
    setError,
    setSuccess,
    clearMessages,
    clearError,
    clearSuccess,
  };
};
